import styled, { css } from 'styled-components';

export const Component = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  ${props => props.full && css`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: #fff;
  `}

  ${props => props.fullHeight && css`
    height: calc(100vh - 30px);
  `}

  ${props => props.small && css`
    padding: 40px 0;
  `}

  ${props => props.fullAbsolute && css`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    background: rgba(255,255,255, 0.9);
  `}
`;

export const Label = styled.div`
  margin-top: 30px;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0.5px;

  ${props => props.small && css`
    margin-top: 20px;
    font-size: 23px;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.styles.js